/** Brand palette aligned with `libs/common/src/lib/styles/_colors.scss`. */
export const NEBALKON_ECHARTS_COLORS = {
  creamyWhite: '#fffaf5',
  midnightBlue: '#140342',
  midnightBlueMedium: '#14034266',
  midnightBlueEasy: '#14034233',
  deepSeaBlue: '#0b6270',
  verdigris: '#37beb0',
  arcticMist: '#dcf6f2',
  arcticMistEasy: '#37beb01a',
  paleGold: '#fee59e',
  brandPink: '#fa436f',
  brandPinkEasy: '#fa436f1a',
  grey: '#f0edff',
  white: '#ffffff',
} as const;

/** Default series palette for dashboard charts. */
export const NEBALKON_ECHARTS_SERIES_COLORS = [
  NEBALKON_ECHARTS_COLORS.verdigris,
  NEBALKON_ECHARTS_COLORS.deepSeaBlue,
  NEBALKON_ECHARTS_COLORS.brandPink,
  NEBALKON_ECHARTS_COLORS.paleGold,
  NEBALKON_ECHARTS_COLORS.arcticMist,
  NEBALKON_ECHARTS_COLORS.midnightBlueMedium,
] as const;
